// base
import { createAction } from '@reduxjs/toolkit';

// default
export const PMT = 'pmt';
export const PMT_SLICE_NAME = `${PMT}Slice`;

// action
const GET_PMT_HISTORY_LIST = `${PMT}/getPmtHistoryList`;
const GET_PMT_HISTORY_LIST_VENDOR = `${PMT}/getPmtHistoryListVendor`;
const GET_PMT_LIST = `${PMT}/getPmtList`;
const CREATE_PMT = `${PMT}/createPmt`;

// createAction
const getPmtHistoryListAction = createAction(GET_PMT_HISTORY_LIST);
const getPmtHistoryListVendorAction = createAction(GET_PMT_HISTORY_LIST_VENDOR);
const getPmtListAction = createAction(GET_PMT_LIST);
const createPmtAction = createAction(CREATE_PMT);

// actions
export const actions = {
  getPmtHistoryListAction,
  getPmtHistoryListVendorAction,
  getPmtListAction,
  createPmtAction
};
